import { createContext, useContext } from 'react';
import type { ComboboxContextValue } from './types';

export const ComboboxContext = createContext<ComboboxContextValue | null>(null);

export function useComboboxContext() {
  const ctx = useContext<ComboboxContextValue | null>(ComboboxContext);
  if (!ctx) {
    throw new Error('useComboboxContext must be used within a ComboboxProvider');
  }
  return ctx;
}
